import moment from 'moment';
import i18n from '../../constants/i18n';

export default ({
	EN: {
		alreadyScheduled: 'It looks like you already have an appointment scheduled.',
		pleaseContact: 'If you have any questions about your appointment, please contact our team.',
		confirmationNo: requestId => `Confirmation #${requestId}`,
		dateTime: appt => `Date/Time: ${moment.utc(appt.startDatetime || appt.blockStartDatetime).format('MMMM D, YYYY h:mm A')} - ${moment.utc(appt.endDatetime || appt.blockEndDatetime).format('h:mm A')}`,
		apptLocation: location => `Location: ${i18n.EN.formatting.location(location)}`,
		pageTitle: 'Existing Appointment'
	},
	ES: {
		alreadyScheduled: 'Parece que ya tienes una cita programada.',
		pleaseContact: 'Si tiene alguna pregunta sobre su cita, póngase en contacto con nuestro equipo.',
		confirmationNo: requestId => `Número de confirmación ${requestId}`,
		dateTime: appt => `Fecha/Hora: ${moment.utc(appt.startDatetime || appt.blockStartDatetime).format('MMMM D, YYYY h:mm A')}-${moment.utc(appt.endDatetime || appt.blockEndDatetime).format('h:mm A')}`,
		apptLocation: location => `Ubicación: ${i18n.ES.formatting.location(location)}`,
		pageTitle: 'Cita Existente'
	}
});
